const URL=window.location.hostname;

module.exports = global.config = {
    apiURLOld: "https://mhdvi1h1l1.execute-api.eu-west-1.amazonaws.com/dev",
    apiURL: "https://cw3ndlfp9k.execute-api.us-east-1.amazonaws.com/dev",
    webURL: (URL==='localhost' ? 'http://localhost:3000': 'https://admin.animationplus.com')
};